import { Box } from "@mui/material";
import React from "react";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import useOperationTranslation from "../hooks/useOperationTranslation";

interface Props {
  subtitle: string;
}

const TransferReasonPage = (props: Props) => {
  const t = useOperationTranslation();
  return (
    <React.Fragment>
      <GenericTitleHeader
        firstTitleHeaderBlue={t("transferReason.titleFirst")}
        secondTitleHeaderViolet={t("transferReason.titleSecond")}
      >
        <Box>{props.subtitle}</Box>
      </GenericTitleHeader>
    </React.Fragment>
  );
};

export default TransferReasonPage;
